import {
  clearSessionStorage,
  getSessionStorage,
  setSessionStorage,
  sessionStorageDictionary,
} from '../../../sessionStorage';
import {UserConfig} from '../ApiService/types/endpoints';

type StoredUserConfig = {
  config: UserConfig;
};

/**
 * UserConfigManager
 * Allow to get, set and clear the configuration.
 * Persist the configuration in the session storage.
 */
class UserConfigManager {
  private config: UserConfig | null = null;

  /**
   * Constructor
   * Load the configuration from the session storage.
   * If the configuration is not found, set it to null.
   */
  constructor() {
    try {
      const storedUserConfig: StoredUserConfig = getSessionStorage(
        sessionStorageDictionary.USER_CONFIG,
      );
      this.config = storedUserConfig?.config;
    } catch (e) {
      // Reset the configuration state
      this.clear();
    }
  }

  /**
   * Get the configuration.
   */
  getConfig(): UserConfig | null {
    return this.config || null;
  }

  /**
   * Set the configuration.
   */
  setConfig(config: UserConfig) {
    this.config = config;

    const storedConfig: StoredUserConfig = {
      config: this.config,
    };

    setSessionStorage(sessionStorageDictionary.USER_CONFIG, storedConfig);
  }

  /**
   * Clear the configuration.
   */
  clear() {
    this.config = null;
    clearSessionStorage(sessionStorageDictionary.USER_CONFIG);
  }
}

const userConfigManager = new UserConfigManager();

export default userConfigManager;
